import * as data from "../data/data.json";
import Item from "../Model/Item";
import Type from "../Model/Type";
import RandomNumberGenerator from "./RandomNumberGenerator";
import { GRID_SIZE } from "../constants";

const SIZE: number = GRID_SIZE * GRID_SIZE - 1;

interface ItemDefinition {
    id: string,
    text: string,
    type: string|string[]
}

interface SetDefinition {
    id: string,
    items: ItemDefinition[],
}

export default class SetGenerator {
    public generate(setId: string, seed: string): Item[] {

        const { datasets } = data;
        const set: SetDefinition |undefined  = datasets.find(({id}: SetDefinition): boolean => id === setId);

        if (set === undefined) {
            throw new Error("Set not found.");
        }

        const items: Item[] = set.items.map(({id, text, type}: ItemDefinition): Item => new Item(id, text, type instanceof Array ? type as Type[] : type as Type));

        return this.pickRandomElements(items, seed);
    }

    private stringNumber(str: string): number {
        let hash: number = 0;
        for (let i: number = 0; i < str.length; i++) {
            const char: number = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash |= 0;
        }

        return hash;
    }

    private pickRandomElements(items: Item[], seed: string): Item[] {
        const randomNumberGenerator: RandomNumberGenerator = new RandomNumberGenerator(this.stringNumber(seed));
        if (SIZE > items.length) {
            throw new Error(`Count cannot be greater than the items length. ${items.length} / ${SIZE}`);
        }

        const shuffled: Item[] = [...items];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = randomNumberGenerator.nextInt(0, i);
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }

        return shuffled.slice(0, SIZE);
    }
}